// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 引入element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'
import App from './App'
import Axios from 'axios'
// 引入视频插件
import 'vue-video-player'
// require videojs style
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
// 引入路由
import router from './router'
// 引入状态管理
import store from './vuex/store'
// 引入icon
import './assets/icon/iconfont.css'
import "./../static/font/font.css"
// 字体自适应
// import './rem.js';


import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'b4faabe6e61dd1815dd86f44261b7ad3',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.DistrictSearch'],
  // 默认高德 sdk 版本为 1.4.4
  v: '2.0'
});
window._AMapSecurityConfig = {
  securityJsCode: '750f7e4fcd95def0a2e922c1ff1c9406',
}

// import VueAMap from 'vue-amap';

// Vue.use(VueAMap);

// // 配置高德地图的API密钥
// VueAMap.initAMapApiLoader({
//   key: 'your_amap_api_key',
//   plugin: ['AMap.DistrictSearch']
// });






// 引入echarts
import * as echarts from 'echarts'
// 过滤器
import * as custom from './utils/util'

Vue.prototype.$echarts = echarts
Vue.prototype.$axios = Axios
Vue.config.productionTip = false

// 使用element UI
Vue.use(ElementUI)

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

/* eslint-disable no-new */
const instance = Axios.create({
  baseURL: process.env.API_HOST,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*'
  }
})
Vue.prototype.$axios = instance
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
    Bus: new Vue()
  }

})



// WEBPACK FOOTER //
// ./src/main.js